<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="notification/notice-pattern/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { NoticePattern } from '@/modules/notification/data/notice-pattern/create'
	import { NoticePatternService } from '@/modules/notification/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return NoticePattern;
			},

			service()
			{
				return new NoticePatternService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>